import React from 'react';
import clsx from 'clsx';

export interface Props {
  children: React.ReactNode;
  isKiosko?: boolean;
  className?: string;
}

export const KioskoWrapper = ({children, isKiosko = false, className}: Props) => {
  if (!isKiosko) {
    return (
      <div className={clsx(className, 'kiosko:w-full kiosko-h-full')}>{children}</div>
    );
  }

  return (
    <div className={clsx(className)}>
      <div>{children}</div>
    </div>
  );
};
